import axios from 'axios';
import { langReplace } from '../constants/lang.constats';

const url = process.env.API_URL + '/api';

export const academyAPI = {
    save,
    getAllLists,
    getAllLessonsByListId,
    savePdf,
    getPdf,
    updateSettingValue,
    getId,
    sendNotificationToFriend,
    shareCertirficateByEmail,
    sendNotificationAfterAddedChangeVideo,
    viewNotification,
    sendFeedback,
    notificationAfterFinishedCourse,
};

function save(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        data,
    };
    return axios(url + `/academy.save`, requestOptions).then(handleResponse);
}

function getAllLists(lang) {
    const switchedLang = langReplace[lang];
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url + `/academy.getAllList?lang=${switchedLang || lang}`,
        requestOptions
    ).then(handleResponse);
}

function getAllLessonsByListId(id) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url + `/academy.getAllLessonsByListId?list_id=${id}`,
        requestOptions
    ).then(handleResponse);
}

function savePdf(blob) {
    const requestOptions = {
        headers: { 'Content-Type': blob.type },
        withCredentials: true,
    };
    return axios
        .post(url + `/academy.savePdf`, blob, requestOptions)
        .then(handleResponse);
}

function getPdf(id) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(url + `/academy.getPdf?id=${id}`, requestOptions).then(
        handleResponse
    );
}

function updateSettingValue(id) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url + `/academy.updateSettingValue?id=${id}`,
        requestOptions
    ).then(handleResponse);
}

function getId() {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(url + `/academy.getId`, requestOptions).then(handleResponse);
}

function sendNotificationToFriend(cerId, friendsIds, userId, listId, title) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url +
            `/academy.sendNotificationToFriend?cerId=${cerId}&friendsIds=${friendsIds}&userId=${userId}&listId=${listId}&title=${title}`,
        requestOptions
    ).then(handleResponse);
}

function shareCertirficateByEmail(email, title, cerId, userId, listId) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url +
            `/academy.shareCertirficateByEmail?cerId=${cerId}&title=${title}&email=${email}&userId=${userId}&listId=${listId}`,
        requestOptions
    ).then(handleResponse);
}

function sendNotificationAfterAddedChangeVideo(listId, title) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url +
            `/academy.sendNotificationAfterAddedChangeVideo?listId=${listId}&title=${title}`,
        requestOptions
    ).then(handleResponse);
}

function viewNotification(item) {
    const requestOptions = {
        method: 'POST',
        withCredentials: true,
    };
    return axios(
        url + `/academy.viewNotification?item=${JSON.stringify(item)}`,
        requestOptions
    ).then(handleResponse);
}

function sendFeedback(name, email, text, country) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
        data: { name, email, text, country },
    };

    return axios(url + `/academy.sendFeedback`, requestOptions).then(
        handleResponse
    );
}

function notificationAfterFinishedCourse(title) {
    const requestOptions = {
        method: 'GET',
        withCredentials: true,
    };
    return axios(
        url + `/academy.notificationAfterFinishedCourse?title=${title}`,
        requestOptions
    ).then(handleResponse);
}
const handleResponse = (response) => {
    return new Promise((resolve, reject) => {
        const data = response.data;
        if (response.status !== 200) {
            const error = (data && data.message) || response.statusText;
            return reject(error);
        }
        return resolve(data);
    });
};
